import React from "react";
import { connect } from "react-redux";

const Profile = (props) => {
  return (
    <div id="ProfileContener">
      <div className="profileTittle">
        {props.languageSet === "en" ? "Full Name" : null}
        {props.languageSet === "pl" ? "Imię i Nazwisko" : null}
      </div>
      <div className="profileText">Prabith GS</div>

      <div id="profileSeparate">
        <div className="profileTittle">
          {props.languageSet === "en" ? "SPECIALIZATION" : null}
          {props.languageSet === "pl" ? "specjalizacja" : null}
        </div>
        <div className="profileText">Reverse Engineer AND Frontend Developer</div>
      </div>

      <div className="profileTittle">
        {props.languageSet === "en" ? "SHORT STORY" : null}
        {props.languageSet === "pl" ? "krótka historia" : null}
      </div>
      <div className="profileText">
        {props.languageSet === "en"
          ? `I am a CSE undergrad at Amrita Vishwa Vidyapeetham,Amritapuri and aspiring software developer.Interested in working on frontend, API, Databases . Currently working on Cyber Security.
          Ever since I was a little kid, software development has been my passion.Throughout high school, me and my friend came up with some ideas for Arduino projects, moving from "Hello World" all the way to Solving real world problems, with dozens of projects in between. I learned Python C and C# then HTML, CSS and Javascript, tearing through any books I could find on anything remotely related to software development. I was insatiable.This passion carried me through my education at SLIIT. Here there were more resources available to me than I ever could have imagined as a kid. I studied new programming languages And it was here that I learned truly how much there was yet to learn.
          So, now, in industry, this passion remains with me. I like apply my knowledge to do something different and unique.`
          : null}
        {props.languageSet === "pl"
          ? `I am a CSE undergrad at Amrita Vishwa Vidyapeetham,Amritapuri and aspiring software developer.Interested in working on backend, API's, Databases . Currently working on Cyber Security.
          Ever since I was a little kid, software development has been my passion.Throughout high school, me and my friend came up with some ideas for Arduino projects, moving from "Hello World" all the way to Solving real world problems, with dozens of projects in between. I learned Python C and C# then HTML, CSS and Javascript, tearing through any books I could find on anything remotely related to software development. I was insatiable.This passion carried me through my education at SLIIT. Here there were more resources available to me than I ever could have imagined as a kid. I studied new programming languages And it was here that I learned truly how much there was yet to learn.
          So, now, in industry, this passion remains with me. I like apply my knowledge to do something different and unique.`
          : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    languageSet: state.lang.languageSet,
  };
};

export default connect(mapStateToProps)(React.memo(Profile));
